import script from "./DetailImkpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailImkpPage.vue?vue&type=script&setup=true&lang=js"

import "./DetailImkpPage.vue?vue&type=style&index=0&id=0eb1ea84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb1ea84"]])

export default __exports__